const {
    find, forEach, trim, isEmpty,
} = require('lodash');
const TealiumEventBuilder = require('../../analytics/tealium/builders/tealium-event-builder');
const $ = require('jquery');

class FulfilmentSelectorService {
    constructor(settings, bootstrap, userPreferenceService) {
        this.settings = settings;
        this.bootstrap = bootstrap;
        this.userPreferenceService = userPreferenceService;

        this.init();
    }

    init() {
        this.isNotServiced = false;
        this.selectedPickupAddress = null;
        this.selectedDeliveryAddress = null;
        this.fulfilmentMethodPickupType = 'pickup';
        this.fulfilmentMethodDeliveryType = 'delivery';

        this.fulfilmentSelectorStepConfirm = 'CONFIRM';
        this.fulfilmentSelectorStepStartShopping = 'START_SHOPPING';
        this.fulfilmentSelectorStepManualAddress = 'MANUAL_ADDRESS';

        this.selectorFulfilmentOptions = [
            {
                name: 'Pick up',
                subheading: this.settings.fulfilmentSelector.pickupOptionSubheading,
                icon: 'iconww-Pickup',
                type: this.fulfilmentMethodPickupType,
                isSelected: false,
            },
            {
                name: 'Delivery',
                subheading: this.settings.fulfilmentSelector.deliveryOptionSubheading,
                icon: 'iconww-Delivery',
                type: this.fulfilmentMethodDeliveryType,
                isSelected: false,
            },
        ];

        this.fulfilmentSelectorSteps = {
            confirm: this.fulfilmentSelectorStepConfirm,
            startShopping: this.fulfilmentSelectorStepStartShopping,
            manualAddress: this.fulfilmentSelectorStepManualAddress,
        };

        this.userPreferenceService.getUserPreference().then((userPreferences) => {
            this.currentStep = this.isStepStartShoppingEnabled(userPreferences)
                ? this.fulfilmentSelectorSteps.startShopping
                : this.fulfilmentSelectorSteps.confirm;

            this.shouldEnableFulfilmentSelectorStartShopping = !(this.isStepStartShoppingEnabled(userPreferences));
            this.hasDismissedRegionalNotification = (this.isRegionalNotificationDismissed(userPreferences));
        });

        this.welcomeMessage = this.settings.fulfilmentSelector.welcomeMessage;

        const shopperInfo = this.bootstrap.getBootstrappedDataIfPresent(this.bootstrap.bootstrapped.Shopper);
        this.shopperName = shopperInfo && shopperInfo.FirstName ? shopperInfo.FirstName : '';

        this.currentlySubscribedToEsc = null;
    }

    isStepStartShoppingEnabled(userPref) {
        return !!userPref && !isEmpty(userPref) && userPref.FulfilmentSelectorStepStartShoppingEnabled;
    }

    isRegionalNotificationDismissed(userPref) {
        return !!userPref && !isEmpty(userPref) && userPref.HasDismissedRegionalNotification;
    }

    setModalTitleMessage(message) {
        this.modalTitleMessage = message;
    }

    getSelectorFulfilmentOption(fulfilmentOptionType) {
        return find(this.selectorFulfilmentOptions, o => o.type === fulfilmentOptionType);
    }

    updateSelectorFulfilmentOptions(optionType) {
        forEach(this.selectorFulfilmentOptions, (o) => {
            o.isSelected = o.type === optionType;
        });
    }

    getFullDeliveryAddress(address) {
        if (isEmpty(address)) return '';

        const street1 = address.Street1 ? `${trim(address.Street1)}, ` : '';
        const suburb = address.SuburbName ? trim(address.SuburbName) : '';
        const state = address.State ? trim(address.State) : '';
        const postCode = address.PostalCode ? trim(address.PostalCode) : '';
        const suburbStatePostcodeText = `${suburb} ${state} ${postCode}`;

        return `${street1}${suburbStatePostcodeText}`;
    }

    isFulfilmentMethodExisting(fulfilmentMethod) {
        if (!fulfilmentMethod) return false;
        if (fulfilmentMethod === this.fulfilmentMethodDeliveryType) return true;
        if (fulfilmentMethod === this.fulfilmentMethodPickupType) return true;
        return false;
    }

    getAddressToDisplay(fulfilmentMethod, address) {
        if (!this.isFulfilmentMethodExisting(fulfilmentMethod) || isEmpty(address)) {
            return null;
        }

        const addressText = address.AddressText ? trim(address.AddressText) : '';
        const street1 = address.Street1 ? trim(address.Street1) : '';
        const suburb = address.SuburbName ? trim(address.SuburbName) : '';
        const state = address.State ? trim(address.State) : '';
        const postCode = address.PostalCode ? trim(address.PostalCode) : '';

        return {
            line1: fulfilmentMethod === this.fulfilmentMethodDeliveryType
                ? street1
                : addressText,
            line2: fulfilmentMethod === this.fulfilmentMethodDeliveryType
                ? `${suburb} ${state} ${postCode}`
                : street1,
        };
    }

    setUserPreferenceFulfilmentSelectorStepStartShopping(newValue) {
        this.userPreferenceService.setFulfilmentSelectorStepStartShopping(newValue);
    }

    setDismissedRegionalNotificationPreference(newValue) {
        this.userPreferenceService.setDismissedRegionalNotificationPreference(newValue);
    }

    subscribeEscPushAnalytics(analyticsService, screenName) {
        this.unsubscribeEsc(this.currentlySubscribed);

        $(document).on('keyup', (evt) => {
            if (evt.keyCode === 27) {
                const event = new TealiumEventBuilder()
                    .withScreenName(screenName)
                    .withLabel('ESC Button')
                    .withEventName('modal_interaction')
                    .build();

                analyticsService.push(event);
            }
        });
        this.currentlySubscribedToEsc = screenName;
    }

    unsubscribeEsc(screenName) {
        if (this.currentlySubscribed === screenName) $(document).off('keyup');
    }
}

FulfilmentSelectorService.$inject = ['Settings', 'BootstrapService', 'UserPreferenceService'];

module.exports = FulfilmentSelectorService;



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector.service.js